import { styled } from '@mui/material';
import { labelFontSemiBold, vars } from '../../../../Theme';
import { GridColumnMenu } from '@mui/x-data-grid-pro';

/**
 * Reduces the default font size of the Data Grid's menu.
 */
export default styled(GridColumnMenu)(() => ({
    '& li .MuiTypography-root': { ...labelFontSemiBold, fontSize: 16, color: vars.font },
}));
